export const SPECS = {
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  CartOOIThunderboltCSSOptimization: 'specs.stores.CartOOIThunderboltCSSOptimization',
  HideDeliveryMethodPickerWithTimeSlots: 'specs.stores.HideDeliveryMethodPickerWithTimeSlots',
  fixEmailNotifierInCart: 'specs.stores.fixEmailNotifierInCart',
  HideCountryPickerInCart: 'specs.stores.HideCountryPickerInCart',
  SupportCardTokenizationOnCartAndCheckout: 'specs.stores.SupportCardTokenizationOnCartAndCheckout',
  ShouldCustomizeCheckoutButton: 'specs.stores.ShouldCustomizeCheckoutButton',
  ShouldUseSideCart: 'specs.stores.ShouldUseSideCart',
  ShouldUseOpenSideCartApiInAddToCart: 'specs.stores.ShouldUseOpenSideCartApiInAddToCart',
  ShouldPreloadCurrentCart: 'specs.stores.ShouldPreloadCurrentCart',
  ShouldUseNewCartQueryAndMutations: 'specs.stores.ShouldUseNewCartQueryAndMutations',
  ShouldUseEcomPlatformPublicApiAddToCartInPP: 'specs.stores.ShouldUseEcomPlatformPublicApiAddToCartInPP',
  AddLoaderWhenUpdateCart: 'specs.stores.AddLoaderWhenUpdateCart',
  UseChevronForItemOptions: 'specs.stores.UseChevronForItemOptions',
  MakeCartItemNameLink: 'specs.stores.MakeCartItemNameLink',
  RemoveLinkFromNonStoresItems: 'specs.stores.RemoveLinkFromNonStoresItems',
  InvalidCartItemQuantity: 'specs.stores.InvalidCartItemQuantity',
  CartItemMoreOptionsFont: 'specs.stores.CartItemMoreOptionsFont',
  NotShowThreeDotsWhenFinishedLoading: 'specs.stores.NotShowThreeDotsWhenFinishedLoading',
} as const;
